import { render, staticRenderFns } from "./edit_service.vue?vue&type=template&id=683e37c6&scoped=true&"
import script from "./edit_service.vue?vue&type=script&lang=js&"
export * from "./edit_service.vue?vue&type=script&lang=js&"
import style0 from "./edit_service.vue?vue&type=style&index=0&id=683e37c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683e37c6",
  null
  
)

export default component.exports